'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('justifyContent', 'justify');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/justify-content.js
// module id = 663
// module chunks = 3